import { type AnalyticsClient, getDatabaseContainerType } from '@databases/analytics';
import { type MessageFormatter } from '@databases/intl/intl-types';
import {
  doInsertEntries,
  doSelectNewEntries
} from '@databases/redux/contextual-menu/actions';
import { appStore } from '@databases/redux/store';
import { DEFAULT_DATABASE_VIEW_SETTINGS } from '@databases/types/database/view';

import { Position } from '../../type.ts';

/**
 * Inserts new entries into a database at the specified position and dispatches related analytics events.
 */
export async function insertEntries({
  position,
  client,
  contentId
}: {
  position: Position;
  client: AnalyticsClient;
  contentId: string;
  formatMessage: MessageFormatter;
}) {
  await appStore.dispatch(
    doSelectNewEntries(contentId, () =>
      appStore.dispatch(
        doInsertEntries(
          contentId,
          DEFAULT_DATABASE_VIEW_SETTINGS,
          position === Position.BEFORE
        )
      )
    )
  );

  await client.sendInsertRowEvent({
    contentId: contentId,
    databaseContainer: getDatabaseContainerType()
  });
}
